import { render } from "./AdminSearch.vue?vue&type=template&id=1747a1b3"
import script from "./AdminSearch.vue?vue&type=script&lang=js"
export * from "./AdminSearch.vue?vue&type=script&lang=js"

import "./AdminSearch.vue?vue&type=style&index=0&id=1747a1b3&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__